import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-[#050811]"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        aria-hidden="true"
        className="absolute h-[420px] w-[420px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(0,240,255,0.14), transparent 62%)" }}
        animate={{ scale: [1, 1.3, 1], opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />

      <motion.div exit={{ opacity: 0, y: -24 }} transition={{ duration: 0.3 }} className="relative flex flex-col items-center">
        <div className="relative">
          <motion.div
            aria-hidden="true"
            className="absolute inset-0 rounded-3xl border border-[#00F0FF]/40"
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: [0.6, 1.35], opacity: [0, 0.9, 0] }}
            transition={{ duration: 1.6, delay: 0.5, times: [0, 0.6, 1], ease: "easeOut" }}
          />
          <svg width="120" height="120" viewBox="0 0 100 100" data-testid="preloader-logo" aria-label="Tarbyte logo">
            <motion.rect
              x="20" y="20" width="60" height="16" fill="#00F0FF"
              style={{ transformOrigin: "50px 28px" }}
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.55, delay: 0.15, ease: EASE }}
            />
            <motion.rect
              x="42" y="36" width="16" height="44" fill="#00F0FF"
              style={{ transformOrigin: "50px 36px" }}
              initial={{ scaleY: 0 }}
              animate={{ scaleY: 1 }}
              transition={{ duration: 0.5, delay: 0.6, ease: EASE }}
            />
            <motion.path
              d="M80 20L64 36H80V20Z" fill="#FFFFFF"
              initial={{ opacity: 0, x: 10, y: -10 }}
              animate={{ opacity: 0.85, x: 0, y: 0 }}
              transition={{ duration: 0.45, delay: 1.0, ease: EASE }}
            />
            <motion.rect
              x="20" y="20" width="60" height="60" fill="none" stroke="#00F0FF" strokeWidth="1"
              style={{ transformOrigin: "50px 50px" }}
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ opacity: [0, 0.5, 0] }}
              transition={{ duration: 1.4, delay: 0.7, ease: "easeInOut" }}
            />
          </svg>
        </div>

        <div className="mt-6 flex overflow-hidden" aria-hidden="true">
          {"TARBYTE".split("").map((letter, i) => (
            <motion.span
              key={i}
              className={`font-display text-2xl font-black tracking-[0.35em] ${i >= 3 ? "text-[#00F0FF]" : "text-white"}`}
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.5, delay: 1.05 + i * 0.055, ease: EASE }}
            >
              {letter}
            </motion.span>
          ))}
        </div>

        <motion.p
          className="mt-3 text-[10px] font-semibold uppercase tracking-[0.45em] text-slate-500"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.5 }}
        >
          Ideas Engineered Digitally
        </motion.p>

        <div className="mt-8 h-px w-44 overflow-hidden bg-white/10">
          <motion.div
            className="h-full bg-gradient-to-r from-[#2563EB] to-[#00F0FF]"
            style={{ transformOrigin: "left" }}
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.9, delay: 0.1, ease: "easeInOut" }}
          />
        </div>
      </motion.div>
    </motion.div>
  );
}
